<template>
  <div class="mask">
    <div class="loginContainer">
      <div>用户登录（登录后才能访问网站）</div>
      <br />
      <el-form :model="form" :rules="rules" ref="form" class="form">
        <el-form-item prop="username" style="width:100%">
          <el-input placeholder="请输入用户名" v-model="form.username">
            <i slot="prefix" class="el-input__icon el-icon-info"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" style="width:100%">
          <el-input type="password" placeholder="请输入密码" v-model="form.password">
            <i slot="prefix" class="el-input__icon el-icon-info"></i>
          </el-input>
        </el-form-item>
        <el-button class="submit" @click="submit()" :loading="loading">登录</el-button>
      </el-form>
    </div>
    <div class="background" @click="close()"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        form: {
          username: "",
          password: ""
        },
        rules: {
          username: [{
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }],
          password: [{
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }]
        }
      }
    },
    methods: {
      close() {
        this.$store.commit("showLoading", false);
      },
      submit() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.loading = true;
            this.$axios.post("/admin/login/token", this.form).then(res => {
              if (res.code == 0) {
                sessionStorage.setItem("userInfo", JSON.stringify(res.data));
                this.$message.success(res.msg);
                this.getUserInfo();
              } else {
                setTimeout(() => {
                  window.location.reload();
                }, this.waitTime);
              }
            }).catch(e => {
              setTimeout(() => {
                window.location.reload();
              }, this.waitTime);
            });
          } else {
            this.$message.error("请先完善信息");
          }
        })
      },
      getUserInfo() {
        this.$axios.get("/web/user/info").then(res => {
          if (res.code == 0) {
            // this.username = res.data.username;
            sessionStorage.setItem("reback", JSON.stringify(res.data));
            setTimeout(() => {
              this.loading = false;
              this.$store.commit("showLoading", false);
              let next = sessionStorage.getItem("next");
              if (next) {
                this.$router.push(next);
              } else {
                this.$router.push("/index");
              }
            }, this.waitTime);
          } else {
            setTimeout(() => {
              window.location.reload();
            }, this.waitTime);
          }
        }).catch(e => {
          setTimeout(() => {
            window.location.reload();
          }, this.waitTime);
        })
      }
    }
  }

</script>

<style scoped>
  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9;
  }

  .loginContainer {
    background: white;
    border-radius: 5px;
    padding: 36px 30px;
  }

  .background {
    width: 100%;
    height: 100vh;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: -1;
  }

  .submit {
    width: 100%;
  }

  .form {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 280px;
    height: 200px;
    flex-direction: column;
  }

</style>



// WEBPACK FOOTER //
// src/views/temp/components/loginTooltip.vue